import { useState, useEffect, Fragment, useMemo } from "react";
import { selectCurrentUser, selectUsers } from 'src/modules/users/selector';
import { useAppDispatch, useAppSelector } from 'src/hooks/redux';
import { selectItems } from "src/modules/spItems/selectors";
import _ from 'lodash';
import { UserAvatar } from "src/components/ui/avatar/Avatar";
import { getItemsRequest } from "src/modules/spItems/api";
import { myTaskActionsHistoryListName } from "src/api/config/myTasksActions.config";
import { addUsers } from "src/modules/users/actions";
import HistoryChanges from "./historyChanges";
import moment from "moment";
import { isStrapi } from "src/api/config/systemSwitch";

const HistoryActionCard = ({ actionID }: any) => {

    const [historyActionCard, setHistoryActionCard] = useState<any>([]);
    const users: any = useAppSelector(selectUsers);
    const dispatch = useAppDispatch();

    useEffect(() => {
        if (actionID) {
            getItemsRequest({ listName: myTaskActionsHistoryListName, filters: { Action: actionID } }).then(results => {
                setHistoryActionCard([...results.items]);
                let usersEmail: any = [];
                // @ts-ignore
                results.items.forEach((item: any) => {
                    Object.keys(item).forEach((key) => {
                        const field = item[key];
                        if (field && !Array.isArray(field) && field.get_email) {
                            if (field.get_email()) {
                                usersEmail = [...usersEmail, field.get_email().toLowerCase()];
                            }
                        }
                        if (field && Array.isArray(field) && field.length > 0 && field[0].get_email) {
                            field.forEach((user) => {
                                if (user.get_email()) {
                                    usersEmail = [...usersEmail, user.get_email().toLowerCase()];
                                }
                            });
                        }
                    });
                });
                usersEmail = _.uniqWith(usersEmail, _.isEqual);
                if (usersEmail.length > 0) {
                    let actualEmails: any = [];
                    usersEmail.forEach((item: string) => {
                        let check = false;
                        Object.keys(users).forEach((key) => {
                            if (key === item) {
                                check = true;
                            }
                        });
                        if (!check) {
                            actualEmails = [...actualEmails, item.toLowerCase()];
                        }
                    });
                    if (actualEmails) {
                        dispatch(addUsers(actualEmails));
                    }
                }
            });
        }
    }, [actionID]);


    return (
        <div className="flex-1 bg-white rounded-lg shadow-xl">
            <div className="relative px-4">
                {historyActionCard.length > 1 &&
                    <div className="absolute left-[14.5px] h-full border border-solid border-[#DFE4EA]"></div>
                }
                {historyActionCard.length > 0 && historyActionCard.map((history: any) => (
                    <div className="history_block flex w-full my-6 -ml-1.5">
                        <div className="pt-5 flex items-start w-2/12 z-10">
                            <div className="w-2.5 h-2.5 bg-[#DFE4EA] rounded-full mr-4 mt-1.5"></div>
                            <span className="text-[#637381] text-sm">{moment(history.Created).format('HH:mm DD.MM.YYYY')}</span>
                        </div>
                        <div className="flex p-5 flex-col justify-center items-start gap-5 flex-[1_0%_0%] w-9/12 rounded-lg border border-solid border-[#DFE4EA]">
                            <div className="w-full items-center flex justify-between">
                                <div className="flex items-center gap-2">
                                    <UserAvatar
                                        avatar={users[history.Author.get_email().toLowerCase().toLowerCase()] && users[history.Author.get_email().toLowerCase()].avatar}
                                        shortName={users[history.Author.get_email().toLowerCase()] && users[history.Author.get_email().toLowerCase()].displayName && users[history.Author.get_email().toLowerCase()].displayName.split(' ')[0][0] + users[history.Author.get_email().toLowerCase()].displayName.split(' ')[1][0]}
                                        displayName={users[history.Author.get_email().toLowerCase()] && users[history.Author.get_email().toLowerCase()].displayName}
                                        email={history.Author.get_email().toLowerCase()}
                                    />
                                    <div className="flex flex-col justify-center items-start">
                                        <span className="text-sm text-[#111928]">{users[history.Author.get_email().toLowerCase()] && users[history.Author.get_email().toLowerCase()].displayName}</span>
                                        <span className="text-sm text-[#637381]" dangerouslySetInnerHTML={{ __html: users[history.Author.get_email().toLowerCase()] && users[history.Author.get_email().toLowerCase()]['jobTitle'] }} />
                                    </div>
                                </div>
                                {isStrapi && history.Status.get_metadata()['Color'] &&
                                    <span className="flex items-center"><svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 10 10" fill="none"><circle cx="5" cy="5" r="5" fill={history.Status.get_metadata()['Color']} />
                                    </svg>&nbsp;&nbsp;<span className={`text-[${history.Status.get_metadata()['Color']}]`}>{history.Status.get_lookupValue()}</span></span>
                                    || history.Status_x003a_Color &&
                                    <span className="flex items-center"><svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 10 10" fill="none"><circle cx="5" cy="5" r="5" fill={history.Status_x003a_Color.get_lookupValue()} />
                                    </svg>&nbsp;&nbsp;<span className={`text-[${history.Status_x003a_Color.get_lookupValue()}]`}>{history.Status.get_lookupValue()}</span></span> ||
                                    <span className="">{history.Status.get_lookupValue()}</span>
                                }
                            </div>
                            <HistoryChanges JsomHistoryFields={history.History} />
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default HistoryActionCard;
